import React from 'react';

import { ApplicationModes } from '../../../common/constants/application-modes';

type ApplicationModeSpecificComponentProps = {
	rovoComponent: React.ReactNode;
	unifiedComponent: React.ReactNode;
	applicationMode: ApplicationModes;
};

const ApplicationModeSpecificComponent = ({
	rovoComponent,
	unifiedComponent,
	applicationMode,
}: ApplicationModeSpecificComponentProps): React.JSX.Element => {
	return (
		<>
			{applicationMode === ApplicationModes.Rovo && rovoComponent}
			{applicationMode === ApplicationModes.Unified && unifiedComponent}
		</>
	);
};

export default ApplicationModeSpecificComponent;
